import { render, staticRenderFns } from "./CreateGreenCoffeeModal.vue?vue&type=template&id=2b84861f&scoped=true"
import script from "./CreateGreenCoffeeModal.vue?vue&type=script&lang=js"
export * from "./CreateGreenCoffeeModal.vue?vue&type=script&lang=js"
import style0 from "./CreateGreenCoffeeModal.vue?vue&type=style&index=0&id=2b84861f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b84861f",
  null
  
)

export default component.exports